import { render, staticRenderFns } from "./CardLoadingTransparent.vue?vue&type=template&id=6d5145ca&scoped=true&"
import script from "./CardLoadingTransparent.vue?vue&type=script&lang=js&"
export * from "./CardLoadingTransparent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5145ca",
  null
  
)

export default component.exports